<canvas #webGlCanvasElement resize (contextmenu)="(false)"></canvas>
